import { api } from '@/common/api';

const store = {
    namespaced: true,
    state() {
        return {
            roles: {}
        };
    },
    mutations: {
        setRoles(state, data) {
            state.roles = data.roles;
        }
    },
    actions: {
        getRoles(state) {
            return new Promise((resolve, reject) => {
                api.get('/roles').then(response => {
                    this.commit('rights/setRoles', response.data.data);
                    resolve(response);
                }, error => {
                    reject(error);
                });
            });
        },
        getUserRoles(state, userId) {
            return new Promise((resolve, reject) => {
                api.get('/roles/' + userId).then(response => {
                    resolve(response);
                }, error => {
                    reject(error);
                });
            });
        },
        updateUserRoles(state, data) {
            return new Promise((resolve, reject) => {
                api.put('/roles/' + data.userId, data.roles).then(response => {
                    resolve(response);
                }, error => {
                    reject(error);
                });
            });
        }
    },
    getters: {}
};

export default store;
